import {createContext} from 'react';

const StackdDataContext = createContext();
export default StackdDataContext